import React from 'react';

import { Group, Skeleton, Title } from '@mantine/core';
import InvoiceStatusBadge from 'components/invoices/InvoiceStatusBadge';
import { UseQueryResult } from 'react-query';
import { InvoiceRetrieve } from 'types';

import { InvoiceDrawerState } from '../types';

interface InvoiceDrawerHeaderProps {
  state: InvoiceDrawerState;
  invoiceQuery: UseQueryResult<{
    data: InvoiceRetrieve;
  }>;
}

const InvoiceDrawerHeader = ({ state, invoiceQuery }: InvoiceDrawerHeaderProps): JSX.Element => {
  const titleStart = state === 'View' ? 'View' : 'Edit';

  if (invoiceQuery.isLoading) {
    return <Skeleton w='200px' h='28px' />;
  }
  if (invoiceQuery.isError) {
    return <Title order={3}>{`${titleStart} Invoice`}</Title>;
  }
  if (invoiceQuery.isSuccess && invoiceQuery.data?.data) {
    return (
      <Group noWrap spacing='xl' sx={{ whiteSpace: 'nowrap' }}>
        <Title order={3}>{`${titleStart} Invoice`}</Title>
        <InvoiceStatusBadge status={invoiceQuery.data?.data.status} />
      </Group>
    );
  }
  return <></>;
};

export default InvoiceDrawerHeader;
